import React, { RefAttributes, useId } from 'react';
import CreatableSelect from 'react-select/creatable';
import { ActionMeta, GroupBase, MultiValue } from 'react-select';
import cx from 'classnames';
import FeedbackError from '@/components/form/FeedbackError/FeedbackError';
import { selectStylesOverride, themeOverride } from '@/components/form/MultiSelect/selectStylesOverride';
import { ClearIndicator, DropdownIndicator } from './selectComponentsOverride';
import Select from 'react-select/base';

export type SelectOptionType = {
  value?: string;
  label?: string;
};

export interface MultiSelectProps<T> {
  ref?: React.Ref<HTMLSelectElement>;
  id?: string;
  name?: string;
  options: SelectOptionType[];
  defaultValue?: SelectOptionType;
  className?: string;
  error?: string;
  onChange?: (e: MultiValue<T>) => void;
  onSelect?: (option: MultiValue<unknown>, actionMeta: ActionMeta<SelectOptionType>) => void;
  placeholder?: string;
  isMulti?: boolean | undefined;
}

const MultiSelect = React.forwardRef<HTMLSelectElement, MultiSelectProps<unknown>>(function MultiSelect(
  { error, className, options, onSelect, isMulti = true, placeholder = 'Adicionar', ...props },
  ref
) {
  const handleChange = (option: MultiValue<unknown>, actionMeta: ActionMeta<SelectOptionType>) => {
    // onSelect we can proxy the value to be handled by another state setter
    if (typeof onSelect === 'function') {
      onSelect(option, actionMeta);
    }
  };

  return (
    <>
      <CreatableSelect
        theme={themeOverride}
        components={{ DropdownIndicator, ClearIndicator }}
        styles={selectStylesOverride}
        // unstyled
        ref={ref as RefAttributes<Select<SelectOptionType, true, GroupBase<SelectOptionType>>>['ref']}
        instanceId={useId()}
        closeMenuOnSelect={true}
        isMulti={(isMulti && true) || undefined}
        options={options}
        // onChange={handleChange}
        placeholder={placeholder}
        formatCreateLabel={(inputValue: string) => (
          <>
            Adicionar: <strong>{inputValue}</strong>
          </>
        )}
        noOptionsMessage={() => 'Sem opções'}
        className={cx(
          {
            'is-invalid': error,
          },
          className
        )}
        {...props}
        onChange={(e: MultiValue<HTMLSelectElement>, actionMeta: ActionMeta<SelectOptionType>) => {
          if (props.onChange) {
            props.onChange(e);
            handleChange(e, actionMeta);
          }
        }}
      />
      <FeedbackError error={error} />
    </>
  );
});

export default MultiSelect;
